$(document).ready(function() {
	$('body').on('click', 'ul.tab li', function() {
		var index = $(this).index();
		$(this).addClass('-active').siblings().removeClass('-active').parent().parent().find('.tabcontent div:nth-child('+(index+1)+')').addClass('-active').siblings().removeClass('-active');
	});
	$('body').on('click', '.tabcontent li a', function() {
		if (!$(this).parent().hasClass('-active'))
			$(this).parent().addClass('-active');
		else
			$(this).parent().removeClass('-active');
	});

	$('body').on('click', '.select-wrapper', function(e) {
		e.stopPropagation();
		e.preventDefault();
		$(this).toggleClass('-visible');
	});

	$(document).click(function() {
		$('.select-wrapper').removeClass('-visible');
	});

	$('body').on('click', '.select-dropdown-element', function(e) {
		var index = $(this).index();
		var pickedText = $(this).find('.select-dropdown-element__text').text();
		$(this).addClass('-picked');
		$(this).siblings().removeClass('-picked');
		$(this).closest('.select-wrapper').find('.select-box__text').text(pickedText);
		$(this).closest('.faq').find('.tabcontent div:nth-child('+(index+1)+')').addClass('-active').siblings().removeClass('-active');
	});
	$('body').on('click', '.select-dropdown-element__text', function() {
		$('.select-wrapper').removeClass('-visible');
	});
	
	$('body').on('click', '.tabcontent li a', function() {
		// if (!$(this).parent().hasClass('-active'))
			// $(this).parent().addClass('-active');
		// else
			// $(this).parent().removeClass('-active');
	});
	
	// var provinceNumber = $('input[name="province"]').val();
	// var province = $('.select-dropdown-element.province[data-key="'+provinceNumber+'"]');
	// var provinceName = province.find('.select-dropdown-element__text').text();
	// var provinceOldText = province.closest('.select-dropdown-wrapper').siblings('.select-box').find('.select-box__text').attr('data-title');
	// if (provinceNumber !== "" && provinceNumber !== '0') {
	// 	province.addClass('-picked');
	// 	province.closest('.select-dropdown-wrapper').siblings('.select-box').find('.select-box__text').empty().append(provinceOldText+': '+provinceName);
	// } else if (!provinceNumber.length){
	// 	province.removeClass('-picked');
	// 	province.closest('.select-dropdown-wrapper').siblings('.select-box').find('.select-box__text').empty().text(provinceOldText);
	// } else {
	// 	province.removeClass('-picked');
	// 	province.closest('.select-dropdown-wrapper').siblings('.select-box').find('.select-box__text').empty().text(provinceOldText);
	// }
});